import { render, staticRenderFns } from "./model_doc.vue?vue&type=template&id=6e4f9618&scoped=true"
import script from "./model_doc.vue?vue&type=script&lang=js"
export * from "./model_doc.vue?vue&type=script&lang=js"
import style0 from "./doc.css?vue&type=style&index=0&id=6e4f9618&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4f9618",
  null
  
)

export default component.exports